import { render, staticRenderFns } from "./LrfqDetails.vue?vue&type=template&id=dd881d10&scoped=true"
import script from "./LrfqDetails.vue?vue&type=script&lang=js"
export * from "./LrfqDetails.vue?vue&type=script&lang=js"
import style0 from "./LrfqDetails.vue?vue&type=style&index=0&id=dd881d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd881d10",
  null
  
)

export default component.exports